export default __webpack_public_path__ + "static/media/img3.0e51e6ea.png";